import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Evento, RegisterEvent } from '../../models/evento';
import { RegisterTicket, Ticket } from '../../models/ticket';
import { EventService } from '../../services/event.service';
import { ToastMensajeService } from '../../services/mensaje-toast.service';
import { TicketService } from '../../services/ticket.service';
import { ClienteSincronizacionService } from '../clientes/cliente-page/cliente-sincronizacion.service';
import { PrintPagoHelper, TipoPago } from '../../models/printPagoHelper';
declare var $: any;

@Component({
  selector: 'app-ticket-modal',
  templateUrl: './ticket-modal.component.html',
  styleUrls: ['./ticket-modal.component.scss']
})
export class TicketModalComponent implements OnInit {

  @Input() esSoloCrearCita: boolean = true;
  @Input() ticketEdicionId: number = null;
  @Input() ticketDetalleId: number = null;
  @Input() ticketEsEditable: boolean = false;
  @Input() cita: Evento;
  @Input() citaId: number;
  @Input() clienteId: number;

  @Output() cancel = new EventEmitter<boolean>(); // Evento para cancelar
  @Output() sendToastMsg: EventEmitter<object> = new EventEmitter<object>(); // delega manejo mensajes en el padre

  public esEdicionCita = false;
  // modal print pago
  public isModalPrintPagoOpen: boolean;
  public pagoTicketSuccess: Ticket; // Pago recien guardado que se mostrara en ticket para imprimir
  public printPagoHelper: PrintPagoHelper;

  constructor(
    protected toastService: ToastMensajeService,
    protected eventService: EventService,
    protected ticketService: TicketService,
    private sincronizacionService: ClienteSincronizacionService
  ) { }

  ngOnInit(): void {
    if (this.citaId) {
      this.getCita();
    } else {
      this.openModal();
    }
  }

  get mostrarCita(): boolean {
    return (!this.cita && (!this.ticketEdicionId && !this.ticketDetalleId)) || this.esEdicionCita;
  }

  get titulo() {
    return this.ticketDetalleId ? 'titulos.ticket.detalle' : (this.ticketEdicionId ? 'titulos.ticket.editar' : (this.esEdicionCita ? 'titulos.ticket.editarCita' : 'titulos.ticket.nuevo'));
  }

  openModal(): void {
    $("#tkCreacion").show();
  }

  onCancel(): void {
    this.cancel.emit(true);
  }

  updateToastMsg(event) {
    if (event.mensajeError) {
      this.toastService.mostrarMensajeError(event.mensaje);
    } else {
      this.toastService.mostrarMensajeOK(event.mensaje);
    }
  }

  onModificarCita(event): void {
    this.cita = event;
    this.esEdicionCita = true;
  }

  onModificarCobro(event): void {
    this.ticketEdicionId = event;
    this.ticketDetalleId = null;
  }

  saveCita(registerEvent: RegisterEvent): void {
    // Determinar si es una actualización o una creación nueva
    const operation = registerEvent.id ?
      this.eventService.update(registerEvent) :
      this.eventService.save(registerEvent);

    operation.subscribe(
      (data) => {
        this.cita = data;
        this.esEdicionCita = false;

        const mensaje = registerEvent.id ?
          'Cita actualizada correctamente' : 'Cita creada correctamente';

        if (this.esSoloCrearCita) {
          this.sendToastMsg.emit({ mensajeError: false, mensaje });
          this.onCancel();
        }
        if (this.clienteId) {
          this.sincronizacionService.emitirActualizacion();
        }
      },
      (error) => {
        const errorMessage = <any>error;
        if (errorMessage != null) {
          this.toastService.mostrarMensajeError(error.error.message);
        }
      }
    );
  }

  saveTicket(registerTicket: RegisterTicket): void {
    const operation = registerTicket.id
      ? this.ticketService.update(this.ticketEdicionId, registerTicket)
      : this.ticketService.save(registerTicket);

    operation.subscribe(
      (data: any) => {
        this.ticketDetalleId = data.id;
        this.ticketEdicionId = null;

        this.pagoTicketSuccess = data;
        this.openPrintPagoModal();

        const mensaje = this.ticketEdicionId
          ? 'Ticket actualizado correctamente'
          : 'Ticket creado correctamente';

        this.sendToastMsg.emit({ mensajeError: false, mensaje });
        if (this.clienteId) {
          this.sincronizacionService.emitirActualizacion();
        }

      },
      (error) => {
        // this.saving = false;
        const mensaje = error?.error?.message || 'Error al guardar el ticket';
        this.sendToastMsg.emit({ mensajeError: true, mensaje });
        this.toastService.mostrarMensajeError(mensaje);
      }
    );
  }

  getCita(): void {
    this.eventService.getById(this.citaId).subscribe(
      (data) => {
        this.cita = data;
        this.esEdicionCita = true;
        this.ticketEdicionId = data.ticketId;
        this.openModal();
      },
      (error) => {
        var errorMessage = <any>error;
        if (errorMessage != null) {
          this.toastService.mostrarMensajeError(error.error.message);
        }
      }
    );
  }

  openPrintPagoModal() {
    this.isModalPrintPagoOpen = true;
    const helper = PrintPagoHelper.desdePago(this.pagoTicketSuccess, TipoPago.Ticket, 'Pago del ticket realizado correctamente');
    this.printPagoHelper = helper;
  }

  closePrintPagoModal() {
    this.isModalPrintPagoOpen = false;
    this.pagoTicketSuccess = null;
    this.printPagoHelper = null;
  }
}
